import React from 'react'

import Skeleton from './Skeleton'
import { NewApiCampaignCard } from './NewApiCampaignCard'
import { OldApiCampaignCard } from './OldApiCampaignCard'
import { ClientCampaignCard } from '/fiweb/components/CampaignCard'

interface Props {
  card?: ClientCampaignCard
  loading?: boolean
  displayForMarketingEmail?: boolean
}

export const CampaignCard = ({ card, loading, displayForMarketingEmail }: Props) => {
  if (loading) {
    return <Skeleton />
  }
  if (!card) {
    return null
  }
  if (card.fromNewApi) {
    return <NewApiCampaignCard cardData={card} displayForMarketingEmail={displayForMarketingEmail} />
  }
  return <OldApiCampaignCard cardData={card} />
}
